import { queryOptions } from '@tanstack/react-query';
import type { AssetDetailType } from '@/common/asset';
import { checkAssetIdIsValid } from '@/lib/utils/asset';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type GetAssetSuccessResponseType = AssetDetailType;

async function getAsset(id: string, deleted: boolean): Promise<GetAssetSuccessResponseType | null> {
	const response = await axios.get(
		`${API_URLS.ASSETS.INDEX}/${id}`,
		deleted ? { params: { deleted: true } } : undefined,
	);
	return getResponse<GetAssetSuccessResponseType>(response.data);
}

/** With `deleted`, loads a deleted asset as a read-only preview (GH #331); a live one is then a 404. */
export function getAssetOptions(id: string, enabled = true, { deleted = false }: { deleted?: boolean } = {}) {
	// Validate Asset ID before making the API call
	const isAssetIdValid = checkAssetIdIsValid(id);
	return queryOptions({
		queryKey: deleted ? ['assets', id, 'deleted'] : ['assets', id],
		queryFn: () => getAsset(id, deleted),
		enabled: enabled && isAssetIdValid,
	});
}
